
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { IPaperlessExtractionLog } from "@/store/types";
import { rawApi } from "@/lib/api";
import notifications from "@/lib/notifications";
import moment from "moment";

@Component({
  components: {}
})
export default class PaperlessBatches extends Vue {
    facilityCode: string = "";     
    batches: IPaperlessExtractionLog[] = [];
    selectedBatch: IPaperlessExtractionLog | null = null;
    showErrorDetails: boolean = false;
    statusFilter: string = "Failed";
    
    statusOptions = [
        { value: "Failed", text: "Failed" }, //badge bg-danger
        { value: "Low Confidence", text: "Low Confidence" },//badge bg-secondary
        { value: "Pending Approval", text: "Pending Approval" }, //badge bg-warning
        { value: "Approved", text: "Approved" } //badge bg-success
    ];

    async mounted() {
        // Restore statusFilter from query parameter if present
        if (this.$route.query.status) {
            this.statusFilter = this.$route.query.status as string;
        }
        await this.loadData();
    }

    async loadData(): Promise<void> {
        try {
            const params = { status: this.statusFilter };
            const response = await rawApi.get('/paperless', { params });
            this.batches = response.data;
        } catch (error) {
            notifications.error("Load Failed", "Unable to load paperless extraction logs.", error);
        } 
    }

    getRowClass(batch: IPaperlessExtractionLog): string {
        let classes = "";
        if (batch.fileErrored) {
            classes += " table-danger";
        } else if (batch.endResult === "Approved") {
            classes += " table-success";
        }
        return classes.trim();
    }

    getResultClass(batch: IPaperlessExtractionLog): string {
        if (batch.endResult === "Approved") {
            return "text-success font-weight-bold";
        } else if (batch.fileErrored) {
            return "text-danger font-weight-bold";
        } 
        return "font-weight-bold";
    }

    onRowClicked(batch: IPaperlessExtractionLog): void {
        this.selectedBatch = batch;
    }

    onRowDoubleClicked(batch: IPaperlessExtractionLog): void {
        this.viewDetails(batch);
    }

    viewDetails(batch: IPaperlessExtractionLog): void {
        // Navigate to details page (BatchesIndex.vue) and preserve statusFilter
        this.$router.push({
            path: `/paperless/batch/${batch.id}`,
            query: { status: this.statusFilter }
        });
    }

    showErrorModal(batch: IPaperlessExtractionLog): void {
        this.selectedBatch = batch;
        this.showErrorDetails = true;
    }

    async onRefreshButtonClicked(): Promise<void> {
        await this.loadData(); 
    }

    formatDate(date: Date | string): string {
        if (!date) return "";
        return moment(date).format("MM/DD/YYYY HH:mm:ss");
    }

    getDuration(batch: IPaperlessExtractionLog): string {
        if (!batch.startDate || !batch.endDate) return "";
        const start = moment(batch.startDate);
        const end = moment(batch.endDate);
        const duration = moment.duration(end.diff(start));
        
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        
        if (hours > 0) {
            return `${hours}h ${minutes}m ${seconds}s`;
        } else if (minutes > 0) {
            return `${minutes}m ${seconds}s`;
        } else {
            return `${seconds}s`;
        }
    }
}
